import { ListItemIcon } from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import BuildIcon from "@material-ui/icons/Build";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { USER_GROUPS, checkRequiredPermissions } from "../../../Utils/Common";
import { showSidebar } from "../../../redux/actions/sidebarActions";

export default function Production() {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  return checkRequiredPermissions([
    USER_GROUPS.ADMIN,
    USER_GROUPS.PRODUCTION,
    USER_GROUPS.SUPER_USER,
  ]) ? (
    <ListItem
      button
      onClick={() => {
        history.push("/production");
        dispatch(showSidebar(false));
      }}
    >
      <ListItemIcon>
        <BuildIcon />
      </ListItemIcon>
      <ListItemText primary={t("mainSideBar.production")} />
    </ListItem>
  ) : null;
}
